import { Route, Switch } from "react-router";
import { Top } from "./pages/Top";
import { InputNoteLink } from "./pages/InputNoleLink";
import { BookSettings } from "./pages/BookSettings";
import { SelectBookCover } from "./pages/SelectBookCover";
import { InputPurchaserInfo } from "./pages/InputPurchaserInfo";
import { InputShippingInfo } from "./pages/InputShippingInfo";
import { ConfirmShippingInfo } from "./pages/ConfirmShippingInfo";
import { OrderCompleted } from "./pages/OrderCompleted";
import { OrderFailed } from "./pages/OrderFailed";
import { HowToUse } from "./pages/HowToUse";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { Inquiry } from "./pages/Inquiry";
import { InquiryCompleted } from "./pages/InquiryCompleted";
import { NotFound } from "./pages/NotFound";
import { CustomCheckout } from "./stripe/CustomCheckout";


const Router = () => {
    return(
        <Switch>
        <Route exact path="/" component={Top} />
        <Route exact path="/input-note-link" component={InputNoteLink} />
        <Route exact path="/book-settings" component={BookSettings} />
        <Route exact path="/select-book-cover" component={SelectBookCover} />
        <Route exact path="/input-purchaser-info" component={InputPurchaserInfo} />
        <Route exact path="/input-shipping-info" component={InputShippingInfo} />
        <Route exact path="/confirm-shipping-info" component={ConfirmShippingInfo} />
        <Route exact path="/order-completed" component={OrderCompleted} />
        <Route exact path="/order-failed" component={OrderFailed} />
        <Route exact path="/how-to-use" component={HowToUse} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/inquiry" component={Inquiry} />
        <Route exact path="/inquiry-completed" component={InquiryCompleted} />
        <Route exact path="/custom-checkout" component={CustomCheckout} />
        <Route exact path="*" component={NotFound} />
        </Switch> 
    )
}

export default Router;